module.exports = __webpack_public_path__ + "img/e7caf0aca2977ff1379bcab47315a8b5.png";